import { useEffect, useState } from "react";

export type FontScale = "base" | "lg" | "xl";
export type AnswerDetail = "" | "brief" | "detailed"; // ""=표준
export type AnswerTone = "" | "polite" | "concise" | "friendly"; // ""=기본

export interface Settings {
  fontScale: FontScale;
  highContrast: boolean;
  notify: boolean; // 브라우저 알림 사용 의사(권한과 별개로 사용자 선택)
  // 답변 옵션(전역 지속) — rag-service 로 전달
  detail: AnswerDetail; // 간단/상세
  tone: AnswerTone; // 말투
  english: boolean; // 영어 답변
  // 답변 모델 셀렉터 선택값(전역 지속) — null 이면 서버 기본값 모델 사용
  chatModelId: number | null;
}

const KEY = "arkiveai.settings";
const DEFAULTS: Settings = {
  fontScale: "base",
  highContrast: false,
  notify: false,
  detail: "",
  tone: "",
  english: false,
  chatModelId: null,
};

/** 서버로 보낼 답변 환경설정(빈 값이면 기본 동작). */
export interface AnswerOptions {
  answer_style: string;
  tone: string;
  lang: string;
}
export function getAnswerOptions(): AnswerOptions {
  return { answer_style: current.detail, tone: current.tone, lang: current.english ? "en" : "" };
}

function load(): Settings {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { ...DEFAULTS };
  }
}

let current: Settings = load();
const listeners = new Set<(s: Settings) => void>();

/** documentElement 에 data-font / data-contrast 적용 (CSS가 이를 참조). */
export function applySettings(s: Settings = current) {
  const el = document.documentElement;
  el.dataset.font = s.fontScale;
  el.dataset.contrast = s.highContrast ? "high" : "normal";
}

export function getSettings(): Settings {
  return current;
}

export function setSettings(patch: Partial<Settings>) {
  current = { ...current, ...patch };
  localStorage.setItem(KEY, JSON.stringify(current));
  applySettings(current);
  listeners.forEach((l) => l(current));
}

export function useSettings(): [Settings, (p: Partial<Settings>) => void] {
  const [s, setS] = useState<Settings>(current);
  useEffect(() => {
    listeners.add(setS);
    return () => {
      listeners.delete(setS);
    };
  }, []);
  return [s, setSettings];
}
